let send = {};

send.vmw_clickCTA = "vmw_clickCTA";
send.vmw_searchError = "vmw_searchError";
send.vmw_downloadVideoFile = "vmw_downloadVideoFile";
send.vmw_downloadVideoError = "vmw_downloadVideoError";
send.vmw_clickHeaderClient = "vmw_clickHeaderClient";
send.vmw_clickFooterClient = "vmw_clickFooterClient";
send.vmw_fromCdYoutube = "vmw_fromCdYoutube";

send.collect = (teaEventName, teaEventValue) => {
    window.collectEvent(teaEventName, teaEventValue);
};

// https://www.volcengine.com/docs/6285/112163#_1-web-js-%E5%81%9C%E7%95%99%E6%97%B6%E9%95%BF%E5%8A%9F%E8%83%BD
send.init = function () {
    window.collectEvent("init", {
        app_id: Number(process.env.VUE_APP_VOLC_ID), //app_id
        channel: "sg", //数据发送地址
        enable_stay_duration: false, //统计页面停留时长
        disable_route_report: false, //自动重置时长
        autotrack: false, // Enabling codeless tracking
        log: process.env.VUE_APP_BUILD_ENVIRONMENT !== "prod", // 开启调试日志
        enable_ab_test: false, // boolean类型，是否开启A/B实验功能
    });
    window.collectEvent("start");
};

send.config = function (userId) {
    window.collectEvent("config", {
        user_unique_id: userId.toString(),
    });
    if (window.clarity) {
        window.clarity("set", "userId", userId.toString());
    }
};

//火山自增属性
send.add = function (value) {
    window.collectEvent("profileIncrement", value);
};
send.append = function (value) {
    window.collectEvent("profileAppend", value);
};

export default send;
